/*
 * Copyright (c) 2024 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
import React from 'react'

import { CountrySelect } from '@/components/ui/CountrySelect'

/**
 * A select element to choose a country. Designed to be used in the desktop header.
 */
const HeaderCountrySelect: React.FC = () => {
  return <CountrySelect className={'bg-primary-500 text-white uppercase text-xs max-w-64 text-ellipsis'} />
}

export { HeaderCountrySelect }
